import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

type Props = {
    className?: string;
};

export const RowDivider = ({ className }: Props) => {
    return <hr className={cn('mt-0 mb-md w-full border-t border-b-0 border-border-secondary', className)} />;
};
